import {css} from '@emotion/react'
import {SwitchButton} from '@/components/Form/index.mjs'

import {
    PropertiesController,
    usePropertiesController,
} from './PropertiesController.jsx'

const cssToggle = css({
    width: 'auto',
    height: 'auto',
    padding: 0,
    border: 'none',
})

export default function PropertiesControllerToggle({
    className,
    style,
    color = '#23b1d9',
    disabled,
    falseIcon,
    falseValue = '0',
    hidden,
    label,
    labelSuffix,
    prop,
    required,
    trueIcon,
    trueValue = '1',
    value,
    ...props
}) {
    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop,
        required,
        value,
    })

    const options = [
        [falseValue, falseIcon],
        [trueValue, trueIcon],
    ]

    return (
        <PropertiesController
            className={className}
            style={style}
            error={p.error}
            hidden={p.hidden}
            inline
        >
            <SwitchButton
                css={cssToggle}
                style={{color}}
                disabled={p.disabled || p.readOnly}
                options={options}
                title={p.label}
                value={p.value}
                onChange={p.onChange}
                {...props}
            />
        </PropertiesController>
    )
}
